import { render, staticRenderFns } from "./InfoSectionPO.vue?vue&type=template&id=899cab94&"
import script from "./InfoSectionPO.vue?vue&type=script&lang=js&"
export * from "./InfoSectionPO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports